import { createI18n } from 'vue-i18n';
import thTH from './locales/th-TH';
import zhCN from './locales/zh-CN';
// 获取浏览器语言设置
const getBrowserLanguage = () => {
  const language = navigator.language;
  if (language.toLowerCase().includes('th')) {
    return 'th-TH';
  }
  return 'zh-CN';
};

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getBrowserLanguage(), // 默认语言
  fallbackLocale: 'th-TH', // 备用语言
  messages: {
    'zh-CN': zhCN,
    'th-TH': thTH,
  },
  missing: (locale: string, key: string) => {
    console.error(locale, key);
    return key;
  },
});

export default i18n;
